/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_View_DetailInputs */

const vi_fleet_view_detail = /** @type {(inputs: Fleet_View_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem chi tiết`)
};

/**

* @param {Fleet_View_DetailInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_view_detail = /** @type {((inputs?: Fleet_View_DetailInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_View_DetailInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_view_detail(inputs)
});